import { useState, useCallback } from "react";
import withStyles from "@mui/styles/withStyles";
// To use date-fns v3.x or v4.x, you need to import the adapter from @mui/x-date-pickers/AdapterDateFnsV3 instead of @mui/x-date-pickers/AdapterDateFns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { FormHelperText } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import { fi } from "date-fns/locale/fi";
import { sv } from "date-fns/locale/sv";
import { enGB } from "date-fns/locale/en-GB";
import { Locale } from "date-fns/locale";
import { COLORS } from "@/modules/styles";
import { DatepickerProps } from "@/components/00-atoms/Datepicker/types.ts";
import { DesktopDatePicker } from "@mui/x-date-pickers";

const styles = createStyles((theme: any) => ({
  root: {
    "& input:focus + fieldset": {
      borderColor: "green !important"
    },
    "& .Mui-disabled": {
      color: COLORS.OIVA_TEXT,
      marginTop: "0.6em",
      padding: 0
    },
    "& label.Mui-disabled": {
      transform: "translate(0, -0.8em) scale(0.75)"
    },
    "& input:disabled + fieldset": {
      borderColor: "transparent !important"
    },
    "& label": {
      color: COLORS.OIVA_TEXT + " !important"
    }
  },
  requiredVisited: {
    "& input + fieldset ": {
      borderColor: COLORS.OIVA_ORANGE,
      borderWidth: 2
    },
    "& input:focus + fieldset": {
      borderColor: "green !important"
    },
    "& label": {
      color: COLORS.OIVA_ORANGE_TEXT + " !important"
    }
  },
  dense: {
    marginTop: theme.spacing(2)
  }
}));

const Datepicker = ({
  ariaLabel = "Datepicker",
  disableFuture = false,
  disablePast = false,
  forChangeObject = {},
  fullAnchor,
  isDisabled = false,
  isHidden = false,
  isReadOnly,
  label = null,
  id = `datepicker-${Math.random()}`,
  locale = "fi",
  showTodayButton = true,
  minDate,
  maxDate,
  onChanges,
  requiredMessage,
  showValidationErrors,
  value
}: DatepickerProps) => {
  const [selectedDate, setSelectedDate] = useState(value);
  const localeMap: Record<string, Locale> = {
    en: enGB,
    fi: fi,
    sv: sv
  };

  const handleDateChange = useCallback(
    (date: any) => {
      if (date) {
        onChanges({ forChangeObject, fullAnchor }, { value: date });
        setSelectedDate(date);
      } else {
        onChanges({ forChangeObject, fullAnchor }, { value: "" });
        setSelectedDate(null);
      }
    },
    [forChangeObject, fullAnchor, onChanges]
  );

  return (
    <LocalizationProvider
      adapterLocale={localeMap[locale]}
      dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        aria-label={ariaLabel}
        slotProps={{
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: showTodayButton ? ["today", "clear"] : ["clear"]
          }
        }}
        className={`${isHidden ? "hidden" : ""} 
        `}
        disabled={isDisabled}
        disableFuture={disableFuture}
        disablePast={disablePast}
        label={label}
        maxDate={maxDate}
        minDate={minDate}
        onChange={handleDateChange}
        readOnly={isReadOnly}
        value={selectedDate ? new Date(selectedDate) : null}
      />
      {showValidationErrors && requiredMessage && (
        <FormHelperText
          id={`${id}-formHelperText`}
          style={{
            marginTop: "0.1em",
            paddingLeft: "1.2em",
            marginBottom: "0.5em",
            color: COLORS.OIVA_ORANGE_TEXT
          }}>
          {!selectedDate && requiredMessage}
        </FormHelperText>
      )}
    </LocalizationProvider>
  );
};
const StyledDatePicker = withStyles(styles)(Datepicker);
export default StyledDatePicker;
